var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 546,
    viewBox: "0 0 752 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2530_87800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.457 232.025V234.093",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.457 239.154V246.737",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.67 3.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.46 249.26V251.328H543.391",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.389 251.328H469.512",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.89 2.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.526 251.328H465.457V253.396",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.457 257.16V292.883",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.73 2.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.457 294.758V296.826",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 234.783V236.851",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 240.891V295.488",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.93 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.141 297.516V299.584H208.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.266 299.582H364.793",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.95 2.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.832 299.582H368.901",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.363 246.691V53.293H418.059V246.691H118.363Z",
    fill: "#CFDDFA",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.044 77.6113C602.374 77.6113 591.944 80.7738 583.073 86.6987C574.202 92.6237 567.287 101.045 563.204 110.898C559.121 120.751 558.053 131.592 560.134 142.052C562.216 152.512 567.354 162.12 574.898 169.661C582.443 177.202 592.055 182.337 602.519 184.418C612.984 186.498 623.831 185.431 633.688 181.349C643.545 177.268 651.97 170.357 657.898 161.49C663.826 152.622 666.99 142.197 666.99 131.533C666.975 117.236 661.287 103.53 651.173 93.4206C641.059 83.3116 627.347 77.6259 613.044 77.6113ZM664.079 130.085H640.52C640.466 121.219 639.185 112.404 636.713 103.89C641.22 101.674 645.398 98.8433 649.127 95.4794C658.359 104.676 663.711 117.062 664.079 130.085ZM613.044 182.572C606.657 182.572 600.63 177.389 595.912 168C594.756 165.652 593.76 163.23 592.933 160.748C599.291 158.037 606.131 156.639 613.044 156.639C619.956 156.639 626.797 158.037 633.154 160.748C632.327 163.23 631.332 165.652 630.175 168C625.513 177.389 619.444 182.572 613.044 182.572ZM613.044 153.744C605.827 153.736 598.683 155.181 592.036 157.99C589.716 149.854 588.51 141.441 588.45 132.98H637.637C637.577 141.441 636.371 149.854 634.051 157.99C627.404 155.181 620.26 153.736 613.044 153.744ZM588.45 130.085C588.502 121.633 589.708 113.228 592.036 105.103C598.687 107.897 605.829 109.336 613.044 109.336C620.258 109.336 627.4 107.897 634.051 105.103C636.372 113.23 637.579 121.634 637.637 130.085H588.45ZM613.044 80.4515C619.43 80.4515 625.458 85.6354 630.175 95.0244C631.354 97.3958 632.376 99.8412 633.237 102.345C626.877 105.065 620.031 106.468 613.113 106.468C606.195 106.468 599.348 105.065 592.988 102.345C593.829 99.8617 594.828 97.4347 595.981 95.0796C600.574 85.6768 606.657 80.4928 613.044 80.4928V80.4515ZM647.031 93.4941C643.64 96.5211 639.859 99.0806 635.789 101.105C634.934 98.6004 633.915 96.1548 632.741 93.7836C630.588 89.0983 627.444 84.9355 623.527 81.582C632.272 83.4208 640.378 87.5292 647.031 93.4941ZM593.236 93.7836C592.072 96.1578 591.059 98.603 590.202 101.105C586.132 99.0806 582.351 96.5211 578.96 93.4941C585.597 87.5378 593.683 83.4299 602.409 81.582C598.541 84.9523 595.441 89.1132 593.319 93.7836H593.236ZM576.933 95.4518C580.661 98.8157 584.839 101.646 589.347 103.862C586.875 112.376 585.593 121.192 585.54 130.057H562.008C562.369 117.038 567.711 104.653 576.933 95.4518ZM562.008 132.953H585.567C585.619 141.819 586.905 150.636 589.388 159.148C584.879 161.361 580.7 164.191 576.974 167.558C567.741 158.372 562.384 145.996 562.008 132.98V132.953ZM579.057 169.557C582.447 166.537 586.222 163.978 590.285 161.947C591.147 164.442 592.161 166.882 593.319 169.254C595.481 173.938 598.629 178.099 602.547 181.456C593.812 179.624 585.711 175.531 579.057 169.585V169.557ZM632.754 169.254C633.923 166.885 634.941 164.444 635.803 161.947C639.865 163.978 643.64 166.537 647.031 169.557C640.391 175.507 632.305 179.609 623.582 181.456C627.481 178.106 630.611 173.953 632.754 169.282V169.254ZM649.141 167.572C645.415 164.205 641.236 161.374 636.727 159.162C639.21 150.65 640.496 141.833 640.548 132.967H664.107C663.745 146.002 658.387 158.4 649.141 167.6V167.572Z",
    fill: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.344 44.5215H131.973V234.756H429.344V44.5215Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.808 53.8008H166.375V180.518H410.808V53.8008Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57 74.0664H369.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 74.0664H328.544",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.238 82.3945H369.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 82.3945H351.124",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.68 90.709H369.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.496 90.709H356.504",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 90.709H328.544",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73 99.0352H369.455",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 99.0352H323.965",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.371 126.789H369.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 126.789H361.607",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.668 135.104H369.455",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 135.104H339.303",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.723 143.43H369.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 143.43H328.544",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66 151.744H369.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.852 151.744H346.28",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.641 151.744H322.889",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.823 80.3958C237.823 80.3958 239.547 81.3333 241.726 77.9003C243.043 75.4032 243.731 72.6231 243.731 69.8004C243.731 66.9777 243.043 64.1975 241.726 61.7005C238.609 56.0891 231.119 56.1856 227.078 56.3924C223.036 56.5992 220.678 51.7186 210.236 56.5579C199.795 61.3972 198.539 68.5526 198.07 74.6328C197.601 80.7129 201.188 86.3104 199.16 89.7986C197.132 93.2867 187.16 94.4724 185.132 101.959C183.105 109.445 187.629 113.636 187.477 115.512C187.325 117.387 184.98 120.185 180.773 122.405C176.567 124.625 172.98 136.592 182.015 143.086C191.05 149.579 201.822 150.42 213.974 143.872C226.126 137.323 234.554 125.176 235.492 118.476C236.43 111.775 233.781 109.9 237.519 107.253C241.257 104.606 245.796 99.9321 243.437 94.3207C241.078 88.7094 237.202 84.5043 237.202 83.098C237.217 82.1637 237.429 81.243 237.823 80.3958Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.023 174.493C197.023 174.493 191.616 182.503 190.761 196.98C189.905 211.456 195.519 231.13 195.519 231.13H247.024C247.024 231.13 250.914 210.808 249.41 197.848C247.907 184.888 245.079 179.25 245.079 179.25L240.941 169.957L198.333 171.046L197.023 174.493Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.922 91.3146C213.922 91.3146 213.77 106.591 213.149 108.452C212.528 110.313 209.715 113.126 201.77 116.559C201.77 116.559 206.914 149.124 207.839 158.789C208.763 168.453 208.777 174.837 208.777 174.837C208.777 174.837 220.322 176.546 225.922 176.216C231.522 175.885 238.239 172.479 238.239 172.479L236.212 114.822L227.48 109.679L227.025 99.5455C227.025 99.5455 217.508 90.5012 216.418 89.8946C215.328 89.2879 213.922 91.3146 213.922 91.3146Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.355 94.7345C217.355 94.7345 224.059 105.544 227.521 108.784L227.08 99.56L217.783 92.1426L217.355 94.7345Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.583 123.881L203.258 125.783C204.844 136.165 207.286 152.42 207.892 158.776C208.83 168.427 208.83 174.824 208.83 174.824C208.83 174.824 220.375 176.534 225.976 176.203C231.576 175.872 238.293 172.467 238.293 172.467L236.583 123.881Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.514 69.5449C232.514 69.5449 223.576 81.8292 213.921 84.821L211.465 85.0968C211.465 85.0968 208.707 81.2777 207.327 84.821C205.948 88.3643 208.707 92.4729 210.334 93.2863C210.86 93.5129 211.433 93.6063 212.003 93.5582C212.574 93.5101 213.123 93.322 213.603 93.0106L214.707 91.9214C214.707 91.9214 220.224 98.1945 223.99 100.387C227.755 102.579 229.507 104.206 231.355 102.289C234.487 98.8541 236.573 94.5974 237.369 90.0188C237.911 85.3968 238.182 80.7473 238.183 76.0938C238.183 76.0938 233.342 69.5449 232.514 69.5449Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.512 78.5488C232.512 78.5488 232.25 83.7328 233.892 84.8219C235.533 85.9111 235.533 87.8275 234.444 88.1033C233.632 88.2583 232.799 88.2583 231.988 88.1033",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.688 90.0195C226.628 90.8845 227.79 91.4715 229.044 91.7149C230.298 91.9584 231.595 91.8487 232.791 91.3982",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.445 81.6647C226.445 82.616 226.101 83.3881 225.673 83.3881C225.245 83.3881 224.887 82.616 224.887 81.6647C224.887 80.7134 225.245 79.9551 225.673 79.9551C226.101 79.9551 226.445 80.6996 226.445 81.6647Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.734 80.864C236.734 81.8015 236.39 82.5736 235.962 82.5736C235.534 82.5736 235.176 81.8015 235.176 80.864C235.176 79.9265 235.534 79.1406 235.962 79.1406C236.39 79.1406 236.734 79.9127 236.734 80.864Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.133 201.611C173.133 201.611 172.085 207.843 171.753 209.249C171.422 210.656 173.133 217.356 173.133 217.356C174.781 218.463 176.51 219.444 178.305 220.293C179.133 220.403 180.54 219.934 180.43 218.914C180.319 217.894 178.664 217.866 178.664 217.866L177.023 215.509L177.367 214.13C177.367 214.13 178.195 216.887 178.747 215.426C179.154 213.842 179.467 212.235 179.685 210.614C180.081 208.601 179.879 206.517 179.105 204.617C178.636 203.238 178.043 201.57 178.043 201.57L178.636 198.813L173.34 197.875L173.133 201.611Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.367 214.103L177.712 209.746",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.705 112.672C208.705 112.672 215.602 172.342 214.76 190.927C214.76 190.927 199.588 190.279 189.67 188.17C189.67 188.17 200.926 158.349 201.132 155.081C201.339 151.813 198.539 146.878 198.539 146.878L180.153 200.909L172.801 198.745L191.836 122.226L208.705 112.672Z",
    fill: "#224B99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.748 130.015L285.341 128.126C286.891 127.698 288.331 126.941 289.562 125.906C290.028 125.412 290.423 124.855 290.734 124.252C291.476 124.187 292.195 123.966 292.844 123.602C293.494 123.239 294.058 122.741 294.5 122.142C295.562 120.267 295.327 114.973 295.327 114.973C295.327 114.973 296.969 112.863 296.845 111.691C296.72 110.52 295.562 110.161 294.265 111.099C292.969 112.036 292.265 112.477 292.265 112.477L285.217 119.523L282.872 121.398C282.563 122.576 282.128 123.717 281.575 124.803C280.872 125.975 279.23 128.208 279.23 128.208L282.748 130.015Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.645 127.161L282.279 123.025C282.279 123.025 283.921 118.558 284.279 117.855C285.756 116.239 287.327 114.71 288.983 113.278C289.328 112.933 291.093 109.404 291.921 109.059C292.748 108.714 293.203 110.107 293.203 111.513C293.203 112.919 290.155 117.386 290.155 117.386C290.155 117.386 289.921 121.523 288.624 123.384C287.588 124.634 286.191 125.535 284.624 125.962",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.645 127.161L282.279 123.025C282.279 123.025 283.921 118.558 284.279 117.855C285.756 116.239 287.327 114.71 288.983 113.278C289.328 112.933 291.093 109.404 291.921 109.059C292.748 108.714 293.203 110.107 293.203 111.513C293.203 112.919 290.155 117.386 290.155 117.386C290.155 117.386 289.921 121.523 288.624 123.384C287.588 124.634 286.191 125.535 284.624 125.962",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.487 88.5566L287.797 127.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.734 124.252C290.734 124.252 289.562 125.19 290.389 120.736",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.3 114.973C295.3 114.973 293.41 116.627 292.707 115.8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.98 111.996C230.98 111.996 234.87 160.251 234.87 172.742C234.87 185.233 235.091 190.252 235.091 190.252C237.055 189.55 239.083 189.042 241.146 188.735C244.25 188.098 247.289 187.175 250.222 185.978C250.222 185.978 239.85 157.452 239.85 155.508C239.85 153.564 241.146 145.554 241.146 145.554C241.146 145.554 259.96 160.913 262.126 160.044C264.292 159.176 283.533 129.919 283.533 129.919L279.644 127.162L258.664 143.155C258.664 143.155 244.608 116.78 243.739 116.353C242.87 115.925 230.98 111.996 230.98 111.996Z",
    fill: "#224B99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.133 145.54L243.519 133.008L245.685 148.78L241.133 145.54Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54 146.835L193.988 137.115",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.344 213.564H131.973V234.755H429.344V213.564Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.344 221.078H131.973V227.255H429.344V221.078Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.284 545.31L460.132 421.336L450.656 423.404L467.815 545.31H472.284Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.032 545.31L349.191 423.404L339.714 421.336L327.562 545.31H332.032Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.517 436.281L336.421 291.31C336.331 289.264 336.658 287.22 337.38 285.303C338.102 283.386 339.206 281.635 340.624 280.156C342.042 278.677 343.745 277.5 345.63 276.697C347.515 275.894 349.544 275.481 351.593 275.482H453.237C455.335 275.476 457.411 275.904 459.334 276.74C461.258 277.576 462.988 278.802 464.413 280.34C465.839 281.878 466.93 283.694 467.618 285.675C468.306 287.656 468.576 289.758 468.41 291.848L457.154 436.281H342.517Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.766 404.516H331.895V436.295H466.766V404.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.516 436.282H332.309L325.164 376.598C325.162 375.459 325.385 374.33 325.821 373.277C326.256 372.224 326.895 371.267 327.701 370.462C328.507 369.656 329.464 369.017 330.518 368.582C331.571 368.147 332.7 367.924 333.84 367.926C336.141 367.926 338.348 368.839 339.975 370.466C341.602 372.092 342.516 374.298 342.516 376.598V436.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.141 436.282H467.348L474.493 376.598C474.494 375.459 474.271 374.33 473.836 373.277C473.401 372.224 472.762 371.267 471.956 370.462C471.15 369.656 470.192 369.017 469.139 368.582C468.086 368.147 466.957 367.924 465.817 367.926C463.516 367.926 461.309 368.839 459.682 370.466C458.055 372.092 457.141 374.298 457.141 376.598V436.282Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.977 324.014L360.804 373.123H436.902L441.716 324.014H355.977Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.943 243.566L346.335 266.328L324.266 333.457H482.89C482.89 333.457 457.455 268.217 452.544 264.812C447.634 261.406 408.529 243.193 408.529 243.193L386.943 243.566Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.426 237.885C385.426 237.885 382.005 240.532 381.288 243.193C380.571 245.854 377.867 267.459 377.867 267.459C377.867 267.459 392.295 257.987 396.461 257.228C400.626 256.47 421.123 268.975 421.123 268.975C421.123 268.975 416.199 244.324 412.406 239.016C408.613 233.708 391.854 231.805 385.426 237.885Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.715 246.6C387.715 246.6 397.95 281.067 398.75 277.331C399.55 273.595 408.626 247.744 408.626 247.744C408.626 247.744 391.494 249.261 387.715 246.6Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.812 222.706C379.812 222.706 382.226 235.997 384.24 241.236C386.254 246.475 393.509 257.34 399.151 256.14C404.792 254.941 414.062 243.249 415.303 238.837C416.544 234.425 418.062 215.868 418.062 211.842C418.062 207.816 414.034 201.778 401.51 205.404C388.985 209.03 380.213 214.655 379.812 222.706Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.316 246.475C393.316 246.475 397.192 248.556 404.351 246.475",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.915 230.468C390.915 231.985 390.308 233.226 389.536 233.226C388.763 233.226 388.156 231.999 388.156 230.468C388.156 228.938 388.777 227.711 389.536 227.711C390.294 227.711 390.915 228.952 390.915 230.468Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.552 230.468C407.552 231.985 406.945 233.226 406.172 233.226C405.4 233.226 404.793 231.999 404.793 230.468C404.793 228.938 405.4 227.711 406.172 227.711C406.945 227.711 407.552 228.952 407.552 230.468Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.415 229.723L401.746 240.077H396.836",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.415 229.723L401.746 240.077H396.836",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.422 225.712C402.422 225.712 406.436 223.216 409.925 225.464L402.422 225.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.422 225.712C402.422 225.712 406.436 223.216 409.925 225.464",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17 225.96C396.17 225.96 392.17 222.72 385.922 225.216L396.17 225.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17 225.96C396.17 225.96 392.17 222.72 385.922 225.216",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.883 211.524L372.035 193.601C372.563 189.202 374.234 185.018 376.881 181.465C379.528 177.912 383.06 175.114 387.125 173.348C393.221 170.712 400.107 170.564 406.311 172.934L406.573 173.03C411.288 174.839 415.355 178.011 418.257 182.142C421.159 186.273 422.762 191.174 422.863 196.22L423.153 210.655",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.717 227.682C375.164 227.811 374.592 227.83 374.032 227.737C373.472 227.645 372.936 227.443 372.455 227.144C371.973 226.844 371.555 226.452 371.225 225.991C370.895 225.53 370.659 225.008 370.53 224.456L368.586 216.06C368.457 215.507 368.438 214.935 368.53 214.376C368.623 213.816 368.825 213.281 369.125 212.799C369.424 212.318 369.816 211.9 370.277 211.57C370.739 211.24 371.261 211.004 371.813 210.876C372.929 210.619 374.1 210.815 375.072 211.419C376.044 212.024 376.737 212.988 377 214.102L378.944 222.512C379.201 223.625 379.005 224.795 378.4 225.764C377.795 226.733 376.83 227.423 375.717 227.682Z",
    fill: "#224B99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.884 227.89C420.744 227.802 419.685 227.266 418.938 226.401C418.192 225.536 417.817 224.411 417.897 223.271L418.532 214.668C418.616 213.527 419.151 212.467 420.017 211.72C420.884 210.973 422.011 210.6 423.153 210.683C423.718 210.724 424.27 210.875 424.777 211.129C425.284 211.383 425.736 211.735 426.106 212.164C426.477 212.594 426.759 213.092 426.936 213.63C427.113 214.169 427.182 214.737 427.139 215.302L426.504 223.905C426.42 225.046 425.885 226.106 425.019 226.853C424.153 227.6 423.025 227.973 421.884 227.89Z",
    fill: "#224B99",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.435 209.415C405.357 213.948 399.969 218.122 394.31 221.906C384.241 228.8 375.372 225.932 375.786 223.919C376.251 222.228 376.928 220.602 377.8 219.08C377.8 219.08 374.172 220.293 373.358 213.441C372.545 206.589 370.945 191.285 378.6 185.246C386.255 179.208 403.58 176.795 411.235 179.208C418.89 181.62 422.118 192.898 422.118 198.137C421.864 203.397 421.325 208.639 420.504 213.841C420.504 213.841 422.118 216.267 417.745 218.28C413.373 220.293 410.09 218.28 410.849 214.654C411.607 211.028 410.435 209.415 410.435 209.415Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.163 315.259C331.163 315.259 335.714 313.356 343.673 316.39C351.632 319.423 367.591 323.972 369.881 323.972C372.17 323.972 385.053 325.117 385.053 325.117L385.44 333.458C385.44 333.458 327.756 334.602 324.335 333.458C320.914 332.314 322.045 321.325 331.163 315.259Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.659 328.784C371.659 328.784 381.784 320.071 384.873 318.099C387.963 316.127 396.694 329.901 396.97 331.031C397.246 332.162 394.722 332.713 394.722 332.713C394.722 332.713 387.977 331.335 386.57 331.031C385.163 330.728 383.811 332.148 380.101 332.148H369.977",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.659 328.784C371.659 328.784 381.784 320.071 384.873 318.099C387.963 316.127 396.694 329.901 396.97 331.031C397.246 332.162 394.722 332.713 394.722 332.713C394.722 332.713 387.977 331.335 386.57 331.031C385.163 330.728 383.811 332.148 380.101 332.148H369.977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.761 315.259C477.761 315.259 473.21 313.356 465.237 316.39C457.264 319.423 441.333 323.972 439.03 323.972C436.726 323.972 423.857 325.117 423.857 325.117L423.484 333.458C423.484 333.458 481.155 334.602 484.575 333.458C487.996 332.314 486.865 321.325 477.761 315.259Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84 328.784C433.84 328.784 423.715 320.071 420.612 318.099C417.508 316.127 408.805 329.901 408.529 331.031C408.253 332.162 410.777 332.713 410.777 332.713C410.777 332.713 417.522 331.335 418.929 331.031C420.336 330.728 421.688 332.148 425.398 332.148H435.523",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84 328.784C433.84 328.784 423.715 320.071 420.612 318.099C417.508 316.127 408.805 329.901 408.529 331.031C408.253 332.162 410.777 332.713 410.777 332.713C410.777 332.713 417.522 331.335 418.929 331.031C420.336 330.728 421.688 332.148 425.398 332.148H435.523",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.02 373.123H360.805V404.902H434.02V373.123Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.551 371.193C367.551 371.193 388.737 376.97 392.6 392.37",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.208 373.11C429.208 373.11 411.869 372.144 406.09 391.405",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.715 391.378C376.446 379.741 368.612 368.905 357.122 366.961C353.475 366.296 349.711 366.778 346.349 368.339C331.907 375.081 346.004 532.654 346.004 532.654H357.577C357.577 532.654 372.694 439.426 375.715 391.378Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.735 523.209L341.328 537.837L329.824 545.158H359.094L359.577 523.209H344.735Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.328 537.838C341.328 537.838 348.652 533.136 353.866 537.838H341.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.328 537.838C341.328 537.838 348.652 533.136 353.866 537.838",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.938 391.378C423.207 379.741 431.041 368.905 442.545 366.961C446.188 366.299 449.946 366.781 453.304 368.339C467.759 375.081 453.649 532.654 453.649 532.654H442.09C442.09 532.654 426.972 439.426 423.938 391.378Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.92 523.209L458.327 537.837L469.817 545.158H440.561L440.078 523.209H454.92Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.323 537.838C458.323 537.838 451.013 533.136 445.785 537.838H458.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.323 537.838C458.323 537.838 451.013 533.136 445.785 537.838",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.839 277.951H443.386C444.3 277.951 445.177 278.314 445.824 278.961C446.471 279.607 446.834 280.484 446.834 281.398V334.051H352.391V281.398C352.391 280.484 352.754 279.607 353.401 278.961C354.047 278.314 354.924 277.951 355.839 277.951Z",
    fill: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.043 278.393C491.517 277.77 492.064 277.206 492.671 276.711",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.678 297.749C495.678 297.749 499.899 293.337 493.278 289.132C489.264 286.567 488.795 283.438 489.706 280.859",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.727 288.002C502.727 288.002 507.858 290.401 506.258 297.653",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.284 301.223H492.711V333.085H514.284V301.223Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.32 328.743H511.072C510.6 328.743 510.147 328.555 509.813 328.222C509.48 327.888 509.292 327.436 509.292 326.964C509.292 326.493 509.48 326.04 509.813 325.707C510.147 325.373 510.6 325.186 511.072 325.186H513.32C514.214 325.186 515.071 324.832 515.705 324.201C516.338 323.571 516.696 322.715 516.699 321.822V314.087C516.696 313.194 516.338 312.338 515.705 311.708C515.071 311.077 514.214 310.723 513.32 310.723H510.479C510.245 310.723 510.014 310.677 509.798 310.588C509.582 310.498 509.386 310.367 509.22 310.202C509.055 310.037 508.924 309.841 508.835 309.625C508.745 309.409 508.699 309.178 508.699 308.945C508.699 308.711 508.745 308.48 508.835 308.264C508.924 308.048 509.055 307.852 509.22 307.687C509.386 307.522 509.582 307.391 509.798 307.301C510.014 307.212 510.245 307.166 510.479 307.166H513.375C515.204 307.166 516.959 307.892 518.252 309.185C519.545 310.478 520.272 312.231 520.272 314.06V321.794C520.279 322.709 520.104 323.616 519.758 324.462C519.411 325.308 518.899 326.077 518.252 326.724C517.605 327.371 516.836 327.882 515.989 328.229C515.142 328.575 514.235 328.75 513.32 328.743Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.981 306.188H253.809V333.458H272.981V306.188Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.093 545.31L558.879 349.74H549.293L565.735 545.31H570.093Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.349 545.31L594.135 349.74H584.535L600.977 545.31H605.349Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.753 545.31L253.726 349.74H244.167L235.422 545.31H239.753Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.306 545.31L214.292 349.74H204.747L195.988 545.31H200.306Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.41 338.711H198.484V355.821H606.41V338.711Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.41 338.711H198.484V344.584H606.41V338.711Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.722 333.016H193.176V339.537H611.722V333.016Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 44.5215H453.195V122.915H575.75V44.5215Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 114.188H453.195V122.915H575.75V114.188Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 117.275H453.195V119.826H575.75V117.275Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.396 83.3325C530.396 79.7631 529.337 76.2738 527.353 73.3059C525.369 70.3381 522.549 68.0249 519.25 66.6589C515.951 65.293 512.321 64.9356 508.818 65.6319C505.316 66.3283 502.099 68.0471 499.574 70.5711C497.048 73.0951 495.329 76.3108 494.632 79.8116C493.935 83.3124 494.293 86.9412 495.66 90.2389C497.026 93.5366 499.34 96.3552 502.31 98.3383C505.279 100.321 508.77 101.38 512.341 101.38C514.712 101.38 517.06 100.913 519.25 100.006C521.441 99.0991 523.431 97.7697 525.108 96.0939C526.785 94.418 528.115 92.4285 529.022 90.2389C529.929 88.0493 530.396 85.7025 530.396 83.3325Z",
    fill: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.795 83.732L507.098 74.6738V92.7901L522.795 83.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 147.719H453.195V226.112H575.75V147.719Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 217.371H453.195V226.098H575.75V217.371Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75 220.473H453.195V223.023H575.75V220.473Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.396 186.514C530.396 182.945 529.337 179.455 527.353 176.488C525.369 173.52 522.549 171.207 519.25 169.841C515.951 168.475 512.321 168.117 508.818 168.814C505.316 169.51 502.099 171.229 499.574 173.753C497.048 176.277 495.329 179.492 494.632 182.993C493.935 186.494 494.293 190.123 495.66 193.421C497.026 196.718 499.34 199.537 502.31 201.52C505.279 203.503 508.77 204.561 512.341 204.561C514.712 204.561 517.06 204.095 519.25 203.188C521.441 202.281 523.431 200.951 525.108 199.275C526.785 197.6 528.115 195.61 529.022 193.421C529.929 191.231 530.396 188.884 530.396 186.514Z",
    fill: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.795 186.916L507.098 177.857V195.974L522.795 186.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.771 270.796H592.48V230.483L598.343 224.857H626.771V270.796Z",
    fill: "white",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.019 230.982H599.519V230.482V228.26L602.283 231.126H592.98V230.982H599.019Z",
    fill: "black",
    stroke: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.934 237.182H621.1",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.934 242.766H621.1",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.934 248.336H621.1",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.934 253.92H621.1",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.934 259.49H621.1",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.179 300.493H635.902V260.18L641.751 254.555H670.179V300.493Z",
    fill: "white",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.44 260.679H642.94V260.179V257.957L645.705 260.824H636.402V260.679H642.44Z",
    fill: "black",
    stroke: "#224B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.355 266.879H664.521",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.355 272.463H664.521",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.355 278.033H664.521",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.355 283.617H664.521",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.355 289.188H664.521",
    stroke: "#224B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1225 413.932C85.0329 415.201 92.1502 415.035 92.1502 415.035C92.1502 415.035 90.6192 410.389 90.495 410.099C88.9364 406.832 83.9984 401.455 79.9707 401.993C79.3062 402.102 78.6722 402.349 78.1098 402.72C77.5473 403.09 77.0691 403.574 76.7062 404.141C76.3432 404.708 76.1037 405.345 76.0031 406.01C75.9025 406.676 75.9431 407.355 76.1223 408.004C76.7982 410.775 79.6534 412.843 82.1225 413.932Z",
    fill: "#288F58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5789 434.517C87.5996 434.958 93.9446 433.138 94.4549 432.973C95.5022 436.606 96.7878 440.166 98.3033 443.63C99.1722 445.643 100.124 447.656 101.062 449.655C100.483 448.8 99.9585 448.056 99.8757 447.959C97.5033 445.202 91.3238 441.328 87.5858 442.913C86.9756 443.196 86.4314 443.603 85.9881 444.108C85.5449 444.614 85.2125 445.206 85.0124 445.848C84.8122 446.489 84.7488 447.166 84.8262 447.834C84.9036 448.501 85.12 449.145 85.4616 449.724C86.841 452.22 90.1376 453.46 92.8135 453.86C95.4894 454.26 100.979 452.785 102.469 452.385C102.841 453.143 103.214 453.915 103.6 454.674C105.434 458.341 107.297 461.981 108.993 465.607C109.6 466.889 110.138 468.171 110.69 469.453C110.179 468.695 109.738 468.075 109.655 467.978C107.297 465.221 101.103 461.347 97.3791 462.932C96.7674 463.213 96.2216 463.619 95.7772 464.124C95.3327 464.629 94.9995 465.222 94.7992 465.865C94.5989 466.507 94.5359 467.184 94.6144 467.852C94.6929 468.52 94.9112 469.165 95.2549 469.743C96.6343 472.252 99.9309 473.479 102.607 473.879C105.283 474.279 110.235 472.955 111.945 472.5C112.469 473.879 112.993 475.161 113.435 476.471C113.724 477.367 114.069 478.222 114.304 479.146L115.048 481.903C115.462 483.64 115.904 485.419 116.276 487.115L116.993 490.561C116.4 489.279 115.214 486.798 115.09 486.605C113.159 483.544 107.641 478.76 103.71 479.711C103.063 479.896 102.462 480.215 101.946 480.647C101.43 481.079 101.011 481.615 100.716 482.219C100.421 482.824 100.256 483.484 100.232 484.156C100.209 484.829 100.327 485.498 100.579 486.122C101.558 488.811 104.634 490.534 107.214 491.334C110.069 492.202 116.373 491.334 117.159 491.334C117.531 493.222 117.876 495.056 118.18 496.848C118.855 500.681 119.366 504.114 119.752 507.023H122.414C121.945 504.004 121.338 500.433 120.538 496.407C120.166 494.491 119.724 492.45 119.255 490.368C121.143 489.607 122.986 488.737 124.773 487.763C126.842 490.01 132.152 492.643 132.842 492.974C132.125 494.753 131.463 496.476 130.69 498.089C129.228 501.467 127.835 504.473 126.552 507.023H129.435C130.483 504.666 131.656 501.991 132.869 499.027C133.614 497.221 134.373 495.277 135.132 493.278C135.89 493.443 142.125 494.656 145.035 494.05C147.67 493.457 150.856 491.968 152.042 489.362C152.341 488.758 152.509 488.098 152.536 487.425C152.563 486.752 152.448 486.081 152.198 485.456C151.948 484.83 151.569 484.264 151.086 483.795C150.603 483.325 150.027 482.963 149.394 482.73C145.559 481.434 139.739 485.805 137.545 488.714C137.408 488.879 136.249 490.906 135.532 492.188C135.835 491.361 136.139 490.575 136.442 489.72C137.063 488.052 137.628 486.37 138.235 484.564C138.497 483.682 138.773 482.786 139.035 481.876C139.297 480.966 139.518 480.014 139.766 479.118C140.277 476.926 140.704 474.679 141.146 472.404C142.608 472.942 147.849 474.748 150.553 474.568C153.256 474.389 156.636 473.383 158.194 470.984C158.57 470.434 158.828 469.812 158.95 469.158C159.073 468.503 159.058 467.83 158.906 467.182C158.754 466.533 158.469 465.924 158.069 465.391C157.668 464.859 157.161 464.416 156.58 464.09C152.98 462.229 146.525 465.662 143.959 468.226C143.794 468.378 142.166 470.419 141.283 471.563C141.504 470.184 141.725 468.805 141.89 467.427C142.387 463.415 142.773 459.334 143.173 455.267C143.284 454.026 143.421 452.785 143.559 451.53C144.07 451.737 150.249 454.026 153.215 453.819C155.973 453.626 159.284 452.633 160.842 450.234C161.221 449.686 161.481 449.065 161.606 448.411C161.731 447.756 161.718 447.083 161.567 446.434C161.416 445.785 161.132 445.175 160.731 444.642C160.331 444.109 159.824 443.666 159.242 443.341C155.629 441.493 149.173 444.912 146.608 447.477C146.415 447.67 144.07 450.607 143.504 451.379C143.794 448.621 144.111 445.864 144.525 443.244C145.074 439.631 145.858 436.057 146.87 432.545C147.104 432.642 153.532 435.068 156.649 434.848C159.339 434.655 162.718 433.662 164.277 431.263C164.656 430.715 164.916 430.094 165.041 429.44C165.165 428.785 165.152 428.112 165.001 427.463C164.851 426.814 164.566 426.204 164.166 425.671C163.766 425.138 163.259 424.695 162.677 424.37C159.063 422.522 152.608 425.941 150.042 428.506C149.849 428.713 147.284 431.87 146.911 432.477C146.911 432.27 147.008 432.049 147.063 431.842C148.177 428.35 149.599 424.964 151.311 421.723C152.222 419.916 153.215 418.248 154.208 416.649C155.353 417.228 160.636 419.792 163.463 419.903C166.291 420.013 169.629 419.393 171.45 417.145C171.894 416.639 172.227 416.046 172.426 415.403C172.626 414.76 172.688 414.083 172.609 413.415C172.53 412.746 172.31 412.102 171.966 411.524C171.621 410.946 171.159 410.446 170.608 410.059C167.229 407.811 160.443 410.514 157.601 412.816C157.449 412.94 156.029 414.36 155.008 415.408C155.463 414.691 155.918 413.947 156.387 413.271C158.084 410.72 159.794 408.487 161.325 406.515C162.208 405.412 163.022 404.42 163.794 403.51C165.174 403.51 170.953 403.303 173.45 402.131C175.946 400.959 178.691 398.836 179.284 396.037C179.443 395.384 179.463 394.705 179.343 394.043C179.223 393.382 178.965 392.753 178.587 392.197C178.209 391.641 177.718 391.17 177.147 390.815C176.576 390.46 175.937 390.229 175.27 390.136C171.243 389.709 166.456 395.224 164.981 398.533C164.856 398.822 163.381 403.51 163.449 403.51H163.532C162.774 404.378 161.974 405.316 161.105 406.35C159.532 408.294 157.767 410.486 156.015 413.009C154.087 415.712 152.319 418.525 150.718 421.433C148.919 424.676 147.41 428.072 146.208 431.58V431.718C146.208 430.532 146.208 427.21 146.208 426.948C145.739 423.363 142.732 416.704 138.745 415.918C138.081 415.817 137.404 415.856 136.756 416.034C136.108 416.211 135.504 416.522 134.984 416.947C134.464 417.372 134.039 417.901 133.737 418.5C133.434 419.1 133.261 419.756 133.228 420.427C132.994 423.28 135.063 426.134 137.077 427.927C139.352 429.953 145.656 431.925 146.166 432.063C145.026 435.674 144.136 439.359 143.504 443.093C143.118 445.271 142.787 447.463 142.497 449.669C142.497 448.635 142.497 447.725 142.497 447.587C142.028 444.002 139.021 437.343 135.035 436.557C134.371 436.454 133.692 436.492 133.043 436.668C132.395 436.844 131.79 437.155 131.27 437.581C130.749 438.006 130.324 438.536 130.022 439.137C129.72 439.737 129.548 440.395 129.518 441.066C129.283 443.92 131.352 446.76 133.366 448.566C135.38 450.372 140.759 452.178 142.18 452.633C142.083 453.474 141.959 454.315 141.863 455.17C141.38 459.237 140.911 463.291 140.332 467.261C140.125 468.64 139.877 470.019 139.628 471.397C139.628 470.487 139.628 469.715 139.628 469.605C139.173 466.02 136.166 459.361 132.18 458.575C131.516 458.474 130.838 458.514 130.19 458.691C129.542 458.868 128.939 459.179 128.419 459.604C127.899 460.029 127.474 460.558 127.171 461.158C126.869 461.757 126.695 462.413 126.662 463.084C126.428 465.938 128.497 468.792 130.511 470.584C132.525 472.376 137.408 474.017 139.063 474.568C138.773 475.947 138.47 477.326 138.125 478.705C137.863 479.615 137.683 480.511 137.366 481.462C137.049 482.413 136.787 483.241 136.511 484.123C135.904 485.805 135.283 487.528 134.649 489.141C134.221 490.272 133.78 491.334 133.352 492.409C133.573 491.03 133.945 488.273 133.945 488.066C133.9 484.883 133.041 481.765 131.449 479.008C131.46 478.653 131.437 478.297 131.38 477.946C131.295 477.279 131.071 476.637 130.722 476.062C130.374 475.487 129.908 474.991 129.355 474.608C128.802 474.224 128.175 473.961 127.514 473.836C126.853 473.71 126.173 473.725 125.518 473.879C121.6 474.927 119.118 481.793 118.924 485.405C118.924 485.626 119.062 487.942 119.173 489.417C118.98 488.562 118.786 487.735 118.58 486.853C118.166 485.129 117.711 483.406 117.2 481.559C116.938 480.676 116.662 479.794 116.4 478.884C116.138 477.974 115.766 477.064 115.448 476.126C114.676 474.003 113.779 471.894 112.842 469.798C114.359 469.426 119.738 468.061 121.876 466.407C124.014 464.752 126.29 462.077 126.276 459.21C126.294 458.537 126.17 457.867 125.912 457.245C125.653 456.623 125.267 456.063 124.778 455.6C124.289 455.137 123.708 454.782 123.072 454.558C122.437 454.335 121.761 454.247 121.09 454.301C117.062 454.743 113.573 461.195 112.814 464.697C112.814 464.918 112.524 467.454 112.428 468.957C111.848 467.703 111.283 466.434 110.662 465.179C108.855 461.553 106.924 457.941 105.007 454.329C104.414 453.226 103.848 452.109 103.269 451.006C103.807 450.882 110.166 449.393 112.635 447.546C114.773 445.905 117.049 443.203 117.035 440.349C117.052 439.676 116.928 439.006 116.67 438.385C116.412 437.763 116.026 437.202 115.536 436.739C115.047 436.276 114.466 435.921 113.831 435.697C113.195 435.474 112.52 435.386 111.848 435.441C107.821 435.882 104.331 442.334 103.572 445.836C103.572 446.098 103.172 449.848 103.131 450.8C101.862 448.359 100.621 445.919 99.5033 443.451C97.961 440.141 96.6386 436.733 95.5446 433.249C95.7929 433.249 102.441 431.663 104.965 429.774C107.103 428.12 109.379 425.431 109.366 422.577C109.383 421.904 109.259 421.235 109.001 420.613C108.743 419.991 108.357 419.43 107.867 418.967C107.378 418.504 106.797 418.15 106.162 417.926C105.526 417.702 104.851 417.615 104.179 417.669C100.152 418.11 96.6619 424.563 95.9032 428.065C95.8343 428.34 95.4756 432.366 95.4618 433.097C95.4618 432.904 95.3101 432.697 95.2549 432.49C94.2548 428.964 93.5671 425.356 93.1997 421.709C92.979 419.696 92.8825 417.766 92.8135 415.877C94.0963 415.725 99.9171 414.953 102.331 413.492C104.745 412.03 107.2 409.659 107.503 406.819C107.595 406.151 107.544 405.472 107.356 404.826C107.167 404.179 106.844 403.579 106.408 403.065C105.973 402.552 105.433 402.136 104.826 401.844C104.218 401.552 103.556 401.392 102.883 401.373C98.8412 401.373 94.6067 407.356 93.5446 410.803C93.5446 410.982 93.0756 412.954 92.7997 414.402C92.7997 413.547 92.7997 412.664 92.7997 411.851C92.7997 408.79 92.9928 405.978 93.1859 403.496C93.3101 402.117 93.448 400.821 93.5859 399.622C94.7584 398.822 99.4481 395.486 100.896 393.156C102.345 390.826 103.448 387.517 102.4 384.883C102.179 384.245 101.825 383.661 101.362 383.168C100.899 382.676 100.338 382.287 99.7138 382.027C99.0901 381.766 98.4184 381.641 97.7427 381.658C97.0671 381.675 96.4026 381.834 95.7929 382.126C92.1928 383.987 91.2411 391.239 91.848 394.796C91.848 395.113 93.2273 399.842 93.3101 399.801H93.3928C93.2273 400.945 93.0756 402.172 92.9239 403.524C92.6756 406.005 92.4273 408.804 92.3583 411.879C92.2415 415.194 92.3198 418.513 92.5928 421.819C92.8844 425.519 93.4982 429.186 94.4273 432.78V432.904C93.7928 431.897 91.9169 429.168 91.7514 428.975C89.3789 426.217 83.1995 422.343 79.4615 423.928C78.8498 424.209 78.304 424.615 77.8596 425.121C77.4151 425.626 77.0819 426.219 76.8816 426.861C76.6813 427.503 76.6183 428.18 76.6968 428.849C76.7753 429.517 76.9936 430.161 77.3373 430.739C78.6063 432.89 81.9029 434.131 84.5789 434.517Z",
    fill: "#288F58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.083 415.491C154.083 415.491 155.366 410.762 155.462 410.458C155.959 406.874 154.814 399.663 151.159 397.898C150.545 397.623 149.88 397.48 149.208 397.479C148.535 397.477 147.87 397.616 147.255 397.888C146.64 398.16 146.089 398.557 145.637 399.056C145.186 399.554 144.844 400.141 144.634 400.78C143.655 403.537 144.896 406.763 146.372 409.052C148.055 411.699 154.069 415.491 154.083 415.491Z",
    fill: "#288F58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.856 545.31H105.972L101.117 502.143H149.725L144.856 545.31Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.016 510.057L102.485 514.234H148.361L148.83 510.057H102.016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.324 523.443L147.793 519.252H103.047L103.516 523.443H147.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.908 545.311H7.51562",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 545H668",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2530_87800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 752,
    height: 546,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginpage);
export default __webpack_public_path__ + "static/media/loginpage.7a8ceda1957045753480e1a62c9b3ac7.svg";
export { ForwardRef as ReactComponent };